import { Tab } from "react-admin";
import {
  ReferencesReviewsField,
  RatingsReviewsField,
  OtherReviewsField,
} from "../../../../components";

const TabReviewsNew = (props) => (
  <Tab label="Reviews" {...props}>
    <ReferencesReviewsField />
    <RatingsReviewsField />
    <OtherReviewsField />
  </Tab>
);

export default TabReviewsNew;
